import React from "react";

const HTMLComputerCode = () => {
  return (
    <div className="html-container">
      <h1>HTML – Computer Code Formatting</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          HTML provides specific elements for displaying computer code, keyboard input, and program output in a readable and structured format.
        </p>
      </section>

      {/* 2. Inline Code */}
      <section id="inline-code">
        <h2>2. Inline Code</h2>
        <p>Use <code>&lt;code&gt;</code> to represent small snippets of code inside a paragraph:</p>
        <p>
          Example: Use <code>className</code> property in JavaScript.
        </p>

        <p>Keyboard input can be represented using <code>&lt;kbd&gt;</code>:</p>
        <p>
          Press <kbd>Ctrl</kbd> + <kbd>S</kbd> to save your work.
        </p>

        <p>File paths:</p>
        <p>
          Navigate to <code>/src/components/</code> directory.
        </p>
      </section>

      {/* 3. Code Blocks */}
      <section id="code-blocks">
        <h2>3. Code Blocks</h2>
        <p>Use <code>&lt;pre&gt;</code> to preserve formatting and line breaks, optionally combined with <code>&lt;code&gt;</code>:</p>

        <pre>
          <code>{`function helloWorld() {
  console.log("Hello, World!");
}`}</code>
        </pre>

        <pre>
          <code>{`<pre><code class="language-python">
def greet(name):
    return f"Hello, {name}!"
</code></pre>`}</code>
        </pre>
      </section>

      {/* 4. Program Output */}
      <section id="program-output">
        <h2>4. Program Output</h2>
        <p>Use <code>&lt;samp&gt;</code> to display program output or system messages:</p>
        <p>Example:</p>
        <samp>Hello, World!<br />Program completed successfully.</samp>

        <p>System messages or errors:</p>
        <samp>Error 404: File not found</samp>
      </section>

      {/* 5. Combining Elements */}
      <section id="combining-elements">
        <h2>5. Combining Elements</h2>
        <p>You can combine <code>&lt;pre&gt;</code>, <code>&lt;code&gt;</code>, and <code>&lt;samp&gt;</code> for better readability:</p>

        <pre>
          <code>{`<pre><code class="language-javascript">
function calculateTotal(price, tax) {
  return price + (price * tax);
}
</code></pre>

<p>After running, output is:</p>
<samp>Total: $120</samp>`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Use <code>&lt;code&gt;</code> for short inline snippets.</li>
          <li>Use <code>&lt;pre&gt;</code> for multi-line code to preserve formatting.</li>
          <li>Use <code>&lt;kbd&gt;</code> for keyboard input instructions.</li>
          <li>Use <code>&lt;samp&gt;</code> for program output or system messages.</li>
          <li>Combine <code>&lt;pre&gt;</code> and <code>&lt;code&gt;</code> for larger code blocks.</li>
          <li>Use syntax highlighting classes (like <code>language-javascript</code>) for modern editors and libraries.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <p>
          HTML provides structured ways to present code, keyboard input, and program output. This ensures better readability, accessibility, and semantic correctness for developers and readers.
        </p>
      </section>
    </div>
  );
};

export default HTMLComputerCode;
